(() => {
  if (window.lccHomeQuickShopReady) return;

  const shop = document.querySelector('[data-lcc-home-shop]');
  if (!shop) return;
  window.lccHomeQuickShopReady = true;

  const rows = Array.from(shop.querySelectorAll('[data-lcc-home-row]'));
  const groups = Array.from(shop.querySelectorAll('[data-lcc-home-group]'));
  const filterButtons = Array.from(shop.querySelectorAll('[data-lcc-home-filter-button]'));

  const formatMoney = (amountInCents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP',
        currencyDisplay: 'narrowSymbol',
      }).format(amountInCents / 100);
    } catch (error) {
      return `£${(amountInCents / 100).toFixed(2)}`;
    }
  };

  const getQuantity = (form) => {
    const input = form.querySelector('[data-lcc-home-quantity]');
    const quantity = Number.parseInt(input?.value || '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };

  const updateTotal = (form) => {
    const input = form.querySelector('[data-lcc-home-quantity]');
    const total = form.querySelector('[data-lcc-home-total]');
    const quantity = getQuantity(form);
    if (input) input.value = String(quantity);
    if (!total) return;

    const unitPrice = Number.parseInt(form.dataset.unitPrice || '0', 10);
    total.textContent = formatMoney(unitPrice * quantity, form.dataset.currency);
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.lccHomeFilterButton;

      filterButtons.forEach((candidate) => {
        candidate.setAttribute('aria-pressed', String(candidate === button));
      });

      rows.forEach((row) => {
        const filters = (row.dataset.lccHomeFilter || '').split(/\s+/).filter(Boolean);
        row.hidden = filter !== 'all' && !filters.includes(filter);
      });

      groups.forEach((group) => {
        group.hidden = !Array.from(group.querySelectorAll('[data-lcc-home-row]')).some((row) => !row.hidden);
      });
    });
  });

  shop.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-lcc-home-quantity-change]');
    if (!quantityButton) return;

    const form = quantityButton.closest('[data-lcc-home-form]');
    const input = form?.querySelector('[data-lcc-home-quantity]');
    if (!form || !input) return;

    const change = Number.parseInt(quantityButton.dataset.lccHomeQuantityChange || '0', 10);
    input.value = String(Math.max(1, getQuantity(form) + change));
    updateTotal(form);
  });

  shop.addEventListener('input', (event) => {
    if (!event.target.matches('[data-lcc-home-quantity]')) return;
    updateTotal(event.target.closest('[data-lcc-home-form]'));
  });

  shop.addEventListener('change', (event) => {
    if (!event.target.matches('[data-lcc-home-quantity]')) return;
    updateTotal(event.target.closest('[data-lcc-home-form]'));
  });

  shop.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-lcc-home-form]');
    if (!form) return;
    event.preventDefault();

    const submitButton = form.querySelector('[data-lcc-home-add]');
    const submitLabel = form.querySelector('[data-lcc-home-add-label]');
    const status = form.querySelector('[data-lcc-home-status]');
    const variantId = form.querySelector('[name="id"]')?.value;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const originalLabel = submitLabel?.textContent || 'Add to basket';

    if (!submitButton || !variantId) return;
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    if (submitLabel) submitLabel.textContent = 'Adding…';
    if (status) status.textContent = '';

    try {
      const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
      if (cart) cart.setActiveElement(submitButton);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: getQuantity(form) }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'This pack could not be added.');
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'lcc-home-quick-shop',
          productVariantId: variantId,
          cartData: result,
        });
      }

      if (cart) {
        cart.renderContents(result);
      } else if (status) {
        status.textContent = 'Added to your basket.';
      }
    } catch (error) {
      if (status) status.textContent = error.message || 'Please try again.';
    } finally {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      if (submitLabel) submitLabel.textContent = originalLabel;
    }
  });

  shop.querySelectorAll('[data-lcc-home-form]').forEach(updateTotal);
})();
